import { Component } from '@angular/core';

@Component({
  selector: 'app-sent-email',
  templateUrl: './sent-email.component.html',
  styleUrls: ['./sent-email.component.scss']
})
export class SentEmailComponent {

  constructor(
  ) {}

}
